/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />

  <ModalConfirmacion v-if="mostrarModalConfirmacion" @confirmar="eliminarUsuario" @cancelar="cancelarEliminacion"
    :nombreUsuario="nombreCliente" />

  <LoadScreen v-if="mostrarLoaderDos" />

  <LayoutPrincipal>
    <ContainerWhite>
      <div style="height: 100%;">

        <section class="filtrosEmpleados">
          <div class="tituloModulo">Módulo Clientes</div>
          <div>
            <input class="inputBuscador" type="text" v-model="searchText"
              placeholder="Buscar por Folio, Nombre o Proyecto" />
          </div>
        </section>

        <section class="tabla-con-loader">
          <div class="tabla-scrollable">
            <table class="default">
              <thead>
                <tr class="cabecera">
                  <th>ID</th>
                  <th>Nombre Completo</th>

                  <th class="desktop-only">Estado</th>
                  <th class="desktop-only">Ciudad</th>
                  <th class="desktop-only">Telefono</th>

                  <th class="desktop-only">Acciones</th>

                  <th class="mobile-only" style="width: 50px;">Ver</th>
                </tr>
              </thead>
              <tbody class="tbody">

                <tr v-if="mostrarLoader" class="fila-loader">
                  <td colspan="8" class="loader-wrapper">
                    <LoadScreenModal class="loader-solo" />
                  </td>
                </tr>

                <tr v-else-if="filteredList.length === 0">
                  <td colspan="8" class="mensajeNoResultados">No se encontraron resultados</td>
                </tr>

                <template v-else v-for="cliente in filteredList" :key="cliente.id_usuario">

                  <tr :class="{ 'fila-activa': isExpanded(cliente.id_usuario) }">
                    <td>
                      <span class="folio-text">{{ String(cliente.id_cliente).padStart(3, '0') }}</span>
                    </td>
                    <td class="nombre-celda">
                      {{ capitalizeWords(cliente.nombre) + ' ' + capitalizeWords(cliente.apellidoPaterno) + ' ' +
                        capitalizeWords(cliente.apellidoMaterno) }}
                    </td>

                    <td class="desktop-only">{{ cliente.estado }}</td>

                    <td class="desktop-only">{{ cliente.localidad }}</td>

                    <td class="desktop-only">{{ cliente.telefono }}</td>

                    <td class="desktop-only">
                      <div class="botonesTabla">
                        <Button class="btn-editar" @click="verCotizaciones(cliente)" title="Ver Cotizaciones">
                          <i class="fa-solid fa-receipt"></i>
                        </Button>
                        <Button class="btn-eliminar" @click="eliminarClienteConfirmacion(cliente)"
                          title="Eliminar cliente">
                          <i class="fa-solid fa-trash"></i>
                        </Button>
                      </div>
                    </td>

                    <td class="mobile-only">
                      <button class="btn-toggle" @click="toggleRow(cliente.id_usuario)">
                        <i
                          :class="isExpanded(cliente.id_usuario) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                      </button>
                    </td>
                  </tr>

                  <tr v-if="isExpanded(cliente.id_usuario)" class="mobile-detail-row">
                    <td colspan="5" class="detail-cell">
                      <div class="detalle-wrapper">

                        <div class="info-grid">

                          <div class="info-item">
                            <span class="label">Estado</span>
                            <span class="value">{{ cliente.estado }}</span>
                          </div>

                          <div class="info-item">
                            <span class="label">Ciudad</span>
                            <span class="value">{{ cliente.localidad }}</span>
                          </div>

                          <div class="info-item full-width">
                            <span class="label">Telefono</span>
                            <span class="value">{{ cliente.telefono}}</span>
                          </div>

                        </div>

                        <div class="botonesTabla mobile-actions">
                          <Button class="btn-editar" @click="verCotizaciones(cliente)" title="Ver Cotizaciones">
                            <i class="fa-solid fa-receipt"></i>
                          </Button>
                          <Button class="btn-eliminar" @click="eliminarClienteConfirmacion(cliente)" title="Eliminar">
                            <i class="fa-solid fa-trash"></i>
                          </Button>
                        </div>

                      </div>
                    </td>
                  </tr>
                </template>

              </tbody>
            </table>
          </div>
        </section>
      </div>
    </ContainerWhite>

    <AgregarAdministrador v-if="mostrarModal" @cancelar="mostrarModal = false" />

    <EditarAdministrador v-if="mostrarModalEditar" :admin="clienteSeleccionado" @cancelar="mostrarModalEditar = false"
      @actualizado="handleClienteActualizado" />
    <Paginacion class="paginacion-fija" :paginaActualEntrada="currentPage" :total="totalPages"
      @changePagina="changePage" />

    <div v-if="mostrarModalCotizacion" class="modal-cotizacion-overlay">
      <div class="modal-cotizacion-content">
        <button @click="cerrarModalCotizacion" class="modal-close-btn" title="Cerrar">&times;</button>

        <LoadScreenModal v-if="cargandoCotizacion" />

        <VerCotizacion v-if="!cargandoCotizacion && datosCotizacion" :formData="datosCotizacion.formData"
          :consumoHistorico="datosCotizacion.consumoHistorico"
          :environmentalBenefit="datosCotizacion.environmentalBenefit"
          :totalCost25Years="datosCotizacion.totalCost25Years" :tirRoi="datosCotizacion.tirRoi"
          :quoteReview="datosCotizacion.quoteReview" :totalKwhHistorico="datosCotizacion.totalKwhHistorico"
          :totalPagoHistorico="datosCotizacion.totalPagoHistorico"
          :accumulatedExpenseChartData="datosCotizacion.accumulatedExpenseChartData"
          :annualConsumptionChartData="datosCotizacion.annualConsumptionChartData"
          :chartDataLoaded="!cargandoCotizacion" :roiDetail="datosCotizacion.roiDetail" />
      </div>
    </div>
  </LayoutPrincipal>
</template>

<script setup>
// 1. IMPORTACIONES
import { ref, onMounted, computed, watch } from 'vue';
import clientService from '../services/clientService.js';
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import ContainerWhite from "../layouts/ContainerWhite.vue";
import Button from "../components/Forms/Button.vue";
import Paginacion from "../components/Forms/Paginacion.vue";
import AgregarAdministrador from "../components/Administrador/AgregarAdministrador.vue";
import EditarAdministrador from "../components/Administrador/EditarAdministrador.vue";
import ModalExito from '../components/Modales/ModalExito.vue';
import ModalConfirmacion from '../components/Modales/ModalConfirmacion.vue';
import LoadScreenModal from "../components/Forms/LoadScreenModal.vue";
import LoadScreen from '../components/Forms/LoadScreen.vue';
import VerCotizacion from "../components/Prospectos/VerCotizacion.vue";

const mostrarLoader = ref(false);
const clientes = ref([]);
const searchText = ref('');
const mostrarExito = ref(false);
const mostrarModalConfirmacion = ref(false);
const nombreCliente = ref('');
const mostrarLoaderDos = ref(false);
const mostrarModal = ref(false);
const mostrarModalEditar = ref(false);
const clienteSeleccionado = ref(null);
const mostrarModalCotizacion = ref(false);
const cargandoCotizacion = ref(false);
const datosCotizacion = ref(null);

const expandedRows = ref([]);

const itemsPerPage = ref(10);
const currentPage = ref(1);

const fetchClientes = async () => {
  mostrarLoader.value = true;
  try {
    const response = await clientService.getAllclients();
    clientes.value = response.data;
  } catch (err) {
    console.error("Error al cargar clientes:", err);
  } finally {
    mostrarLoader.value = false;
  }
};

onMounted(fetchClientes);

const filteredAndSortedList = computed(() => {
  let listaFiltrada = clientes.value;


  if (searchText.value) {
    const search = searchText.value.toLowerCase();
    listaFiltrada = listaFiltrada.filter(cliente => {
      return (
        (cliente.id_cliente && String(cliente.id_cliente).padStart(3, '0').includes(search)) ||
        (cliente.nombre && cliente.nombre.toLowerCase().includes(search)) ||
        (cliente.codigo_proyecto && cliente.codigo_proyecto.toLowerCase().includes(search))
      );
    });
  }


  return [...listaFiltrada].sort((a, b) => {
    return a.id_cliente - b.id_cliente;
  });
});

const totalPages = computed(() => {
  return Math.ceil(filteredAndSortedList.value.length / itemsPerPage.value);
});

const filteredList = computed(() => {
  const listaCompleta = filteredAndSortedList.value;
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return listaCompleta.slice(start, end);
});

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

watch(searchText, () => {
  currentPage.value = 1;
});

const capitalizeWords = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const toggleRow = (id) => {
  if (expandedRows.value.includes(id)) {
    expandedRows.value = expandedRows.value.filter(rowId => rowId !== id);
  } else {
    expandedRows.value.push(id);
  }
};

const isExpanded = (id) => {
  return expandedRows.value.includes(id);
};

const handleClienteActualizado = async () => {
  mostrarModalEditar.value = false;
  mostrarExito.value = true;
  setTimeout(() => { mostrarExito.value = false; }, 2000);
  await fetchClientes();
};

const eliminarClienteConfirmacion = (cliente) => {
  clienteSeleccionado.value = cliente;
  const nombreC = capitalizeWords(cliente.nombre);
  const apePatC = capitalizeWords(cliente.apellidoPaterno);
  const apeMatC = capitalizeWords(cliente.apellidoMaterno);
  nombreCliente.value = `${nombreC} ${apePatC} ${apeMatC}`.trim();

  mostrarModalConfirmacion.value = true;
};

const cancelarEliminacion = () => {
  mostrarModalConfirmacion.value = false;
  clienteSeleccionado.value = null;
  nombreCliente.value = '';
};

const eliminarUsuario = async () => {
  if (!clienteSeleccionado.value) return;

  mostrarModalConfirmacion.value = false;
  mostrarLoaderDos.value = true;

  try {
    const idParaEliminar = clienteSeleccionado.value.id_cliente;
    await clientService.deleteClient(idParaEliminar);

    clientes.value = clientes.value.filter(
      cliente => cliente.id_cliente !== idParaEliminar
    );

    mostrarExito.value = true;
    setTimeout(() => { mostrarExito.value = false; }, 2000);

  } catch (error) {
    console.error("Error al eliminar el cliente:", error);
  } finally {
    mostrarLoaderDos.value = false;
    clienteSeleccionado.value = null;
    nombreCliente.value = '';
  }
};

const verCotizaciones = async (cliente) => {
  mostrarModalCotizacion.value = true;
  cargandoCotizacion.value = true;
  datosCotizacion.value = null;

  try {
    await new Promise(resolve => setTimeout(resolve, 1000));

    datosCotizacion.value = {
      formData: {
        ...cliente,
        codigoProyecto: cliente.codigo_proyecto,
        nombreProyecto: `Proyecto ${capitalizeWords(cliente.nombre)}`,
        localidadProyecto: 'Culiacán, Sinaloa',
        tarifaCFE: 'GDMTH',
        numeroServicio: '123456789'
      },
      consumoHistorico: [
        { inicio: '2024-01', termino: '2024-02', kwPunta: 15.5, kwhTotales: 5000, pago: 15000 },
        { inicio: '2024-02', termino: '2024-03', kwPunta: 16.0, kwhTotales: 5200, pago: 15500 },
        { inicio: '2024-03', termino: '2024-04', kwPunta: 15.0, kwhTotales: 4900, pago: 14800 },
      ],
      environmentalBenefit: { co2Reduced: 32000, treesPlanted: 50, kmNotDriven: 15000.55 },
      totalCost25Years: { withoutPanels: 5000000, withPanels: 1500000, savings: 3500000 },
      tirRoi: { tir: 25.42, roiYears: 3, roiMonths: 6 },
      quoteReview: [],
      totalKwhHistorico: 15100,
      totalPagoHistorico: 45300,
      accumulatedExpenseChartData: {},
      annualConsumptionChartData: {},
      chartDataLoaded: true,
      roiDetail: [
        { periodo: 'Bimestre 1', consumo: 5000, generada: 4000, nuevoPago: 5000, pagoHistorico: 15000, ahorro: 10000 },
        { periodo: 'Bimestre 2', consumo: 5200, generada: 4100, nuevoPago: 5200, pagoHistorico: 15500, ahorro: 10300 },
        { periodo: 'Bimestre 3', consumo: 4900, generada: 3900, nuevoPago: 4900, pagoHistorico: 14800, ahorro: 9900 },
      ],
    };
  } catch (error) {
    console.error("Error al cargar la cotización:", error);
  } finally {
    cargandoCotizacion.value = false;
  }
};

const cerrarModalCotizacion = () => {
  mostrarModalCotizacion.value = false;
  datosCotizacion.value = null;
};
</script>

<style scoped>

.filtrosEmpleados {
  justify-content: space-between;
  display: flex;
  padding: 20px 20px 20px 50px;
  align-items: center;
}

.tituloModulo {
  font-size: 25px;
  color: #2a428c;
  font-weight: bolder;
  font-style: italic;
}

.status-activo {
  font-weight: bold;
  color: green;
}

.status-pendiente {
  font-weight: bold;
  color: orange;
}

.inputBuscador {
  width: 300px;
  height: 42px;
  max-width: 250px;
  margin-right: 0;
  z-index: 10;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  margin-right: 20px;
}

.inputBuscador:focus {
  outline: none;
  border-color: #29b9f6;
  box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.tablaPrincipal {
  width: 100%;
  overflow-x: auto;
  overflow-x: hidden;
}

.default {
  border-collapse: collapse;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
}

.cabecera {
  background: black;
  color: white;
  height: 50px;
}

.default td,
.default th {
  border: none;
  padding: 15px 12px;
  text-align: center;
}

.default tr:nth-child(even) {
  background-color: #f8fafc;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}

.tbody {
  font-size: 14.5px;
}

.mensajeNoResultados {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #691c32;
  padding: 20px 0;
}

.paginacion-fija {
  margin-top: auto;
}

.tabla-con-loader {
  position: relative;
}

.fila-loader {
  position: relative;
  height: 58vh;
}

.tabla-scrollable {
  max-height: 72vh;
  overflow-y: auto;
  background: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #000;
  color: white;
  z-index: 10;
}

.modal-cotizacion-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-cotizacion-content {
  background-color: white;
  padding: 40px;
  border-radius: 12px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.modal-close-btn {
  position: absolute;
  top: 15px;
  right: 25px;
  background: none;
  border: none;
  font-size: 30px;
  color: #333;
  cursor: pointer;
  line-height: 1;
  z-index: 10000;
}

.mobile-only {
  display: none;
}

.mobile-detail-row {
  display: none;
}




@media (max-width: 810px) {

  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: table-cell;
    vertical-align: middle;
  }

  .tituloModulo {
    font-size: 25px;
    margin-bottom: 15px;
  }

  .filtrosEmpleados {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }

  .inputBuscador {
    max-width: 250px;
    margin-right: 0;
    z-index: 10;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 0 15px;
    font-size: 14px;
    transition: border-color 0.3s, box-shadow 0.3s;
  }

  .default {
    table-layout: auto;
  }

  .default th {
    font-size: 14px;
    letter-spacing: 0;
    padding: 10px 4px;
  }

  .default td {
    padding: 12px 5px;
    font-size: 13px;
    vertical-align: middle;
  }


  .nombre-celda {
    font-weight: 600;
    color: #333;
    line-height: 1.2;
  }

  .btn-toggle {
    background: transparent;
    border: none;
    font-size: 18px;
    color: #29b9f6;
    cursor: pointer;
    padding: 8px;
  }

  .fila-activa {
    background-color: #fff8f5 !important;
    border-bottom: 2px solid #29b9f6;
  }

  .mobile-detail-row {
    display: table-row;
    animation: fadeIn 0.3s ease-out;
  }

  .default tr.mobile-detail-row,
  .default tr.mobile-detail-row:nth-child(even),
  .default tr.mobile-detail-row:nth-child(odd) {
    background-color: #fafafa;
    box-shadow: inset 0px 5px 10px -5px rgba(0, 0, 0, 0.1);
  }

  .detail-cell {
    padding: 0 !important;
  }

  .detalle-wrapper {
    padding: 20px 15px;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 15px;
    text-align: left;
  }

  .info-item {
    display: flex;
    flex-direction: column;
  }

  .info-item.full-width {
    grid-column: span 2;
  }

  .label {
    font-size: 11px;
    color: #888;
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 3px;
  }

  .value {
    font-size: 14px;
    color: #222;
    word-break: break-word;
  }

  .mobile-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding-top: 10px;
    border-top: 1px solid #e0e0e0;
  }

  .mobile-actions .btn-editar,
  .mobile-actions .btn-eliminar {
    width: 35px;
    height: 35px;
    font-size: 16px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-cotizacion-content {
    padding: 20px;
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>